var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-more-task",on:{"click":_vm.loadMoreTasks}},[(_vm.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('span',[_vm._v(" Mostrar más tareas... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }